module.exports = __webpack_public_path__ + "static/media/sound.b8ecce2c.svg";